import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'small' | 'medium' | 'large';
}

export const Button = styled.button<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: ${theme.borderRadius.md};
  font-weight: ${theme.typography.fontWeights.bold};
  cursor: pointer;
  transition: all ${theme.transitions.fast};
  text-decoration: none;
  
  /* Size variants */
  padding: ${props => {
    switch (props.size) {
      case 'small':
        return '8px 16px';
      case 'large':
        return '14px 28px';
      default:
        return '12px 24px';
    }
  }};
  
  font-size: ${props => {
    switch (props.size) {
      case 'small':
        return theme.typography.sizes.sm;
      case 'large':
        return theme.typography.sizes.lg;
      default:
        return theme.typography.sizes.md;
    }
  }};
  
  /* Style variants */
  background-color: ${props => {
    switch (props.variant) {
      case 'secondary':
        return '#232B3B';
      case 'outline':
        return 'transparent';
      default:
        return '#FFD700';
    }
  }};
  
  color: ${props => {
    switch (props.variant) {
      case 'secondary':
        return 'white';
      case 'outline':
        return '#232B3B';
      default:
        return '#232B3B';
    }
  }};
  
  border: ${props => props.variant === 'outline' ? '2px solid #232B3B' : 'none'};
  
  &:hover {
    background-color: ${props => {
      switch (props.variant) {
        case 'secondary':
          return '#1a1f2e';
        case 'outline':
          return '#232B3B';
        default:
          return '#e6c200';
      }
    }};
    
    color: ${props => props.variant === 'outline' ? 'white' : props.color};
  }
  
  &:disabled {
    background-color: ${theme.colors.neutral.lightGrey};
    color: ${theme.colors.neutral.grey};
    cursor: not-allowed;
  }
`;